var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"mask-image",style:({
  'mask-image': `url(${_vm.path})`,
  '-webkit-mask-image': `url(${_vm.path})`,
  background: _vm.mask,
})},'div',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }